export class GetChargeAccountUserIdsEntity {
    usersIds;

    constructor(usersIds) {
        this.usersIds = usersIds;
    }
}